export default __webpack_public_path__ + "static/media/Saudia.ca6e0f57.png";